import axios from "axios";
import { HTTP_METHODS } from "../constants/enums";
import { STATUS_CODES } from '../constants/statusCodes';
import {getAuthToken} from "./authHelper";

export const sendRequest = (URL, method = HTTP_METHODS.GET, data, option, callback) => {

  const headers = {
    "Content-Type": "application/json",
    'Authorization': `${getAuthToken()}`,
    ...(option && option.headers)
  }

  const fetchParams = {
    method: method,
    headers: headers
  }

  if (method === HTTP_METHODS.POST || method === HTTP_METHODS.PUT) {

    fetchParams.body = typeof data === "string" ? data : JSON.stringify(data)

    axios({
      method: fetchParams.method,
      url: URL,
      data: fetchParams.body,
      headers: fetchParams.headers,
      withCredentials: true
    })
        .then(function(data) {
          callback(null, data)
        })
        .catch(error => {
          if (error.response) {
            callback(error.response, {})
          }
        })

  } else {

    axios({
      method: fetchParams.method,
      url: URL,
      headers: fetchParams.headers,
      withCredentials: true
    })
        .then(function(data) {
          callback(null, data)
        })
        .catch(error => {
          if (error.response) {
            callback(error.response, {})
          }
        })

  }
}

export const sendFileRequest = (URL, method = HTTP_METHODS.GET, data, option, callback) => {
  let headers = {
    ENCTYPE: "multipart/form-data",
    'Authorization': `${getAuthToken()}`,
    ...(option && option.headers)
  }

  const fetchParams = {
    method: method,
    headers: headers
  }

  fetchParams.body = data

  axios({
    method: fetchParams.method,
    url: URL,
    data: fetchParams.body,
    headers: fetchParams.headers,
    withCredentials: true
  })
      .then(function(data) {
        callback(null, data)
      })
      .catch(error => {
        if (error.response) {
          callback(error.response, {})
        } else {
          callback('Unknown error on upload file request', {})
          console.log('Unknown error on upload file request', error)
        }
      })
}

export const getFileRequest = (URL, method = HTTP_METHODS.GET, data, option, callback) => {
  let headers = {
    "Content-Type": "application/json",
    'Authorization': `${getAuthToken()}`,
    ...(option && option.headers)
  }

  const fetchParams = {
    method: method,
    headers: headers
  }

  fetchParams.body = data;
  axios({
    method: fetchParams.method,
    url: URL,
    data: fetchParams.body,
    headers: fetchParams.headers,
    withCredentials: true,
    responseType: "blob"
  })
      .then(function(data) {
        callback(null, data)
      })
      .catch(error => {
        if (error.response) {
          callback(error.response, {})
        }
      })
}

axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response.status === STATUS_CODES.UNVERIFIED) {
      window.location.href = "/login";
    }
    return error;
  }
)